export const StorageKeys = {
    LAST_SHIFT_UPDATE_CHECK_TIME: 'last-shift-update-checked-at',
    TIMEZONE_STORAGE_KEY: 'timezone',
}
